import { useMutation } from '@tanstack/react-query';
import { clioSearchApi } from '../api/clioSearchApi';

/**
 * Hook for searching matters
 * Can be used across any feature in the application
 */
export function useSearchMatters() {
  return useMutation({
    mutationFn: clioSearchApi.searchMatters,
  });
}

/**
 * Hook for searching bank accounts
 * Can be used across any feature in the application
 */
export function useSearchBankAccounts() {
  return useMutation({
    mutationFn: clioSearchApi.searchBankAccounts,
  });
}
